var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:['btnClip', 'clip' + _vm.clipSide, _vm.clickActive]},_vm.$listeners),[_c('div',{staticClass:"z-100"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }